<ng-container *ngIf="isDevMode()">
    <span style="font-size: 14px"><strong>debug: {{tag}}</strong></span>
</ng-container>
